export default __webpack_public_path__ + "static/media/Boots of the Faceless Chaos.83da6542.jpg";